// extracted by mini-css-extract-plugin
export default {"card":"UY-z","carouselContainer":"VY-z","carouselContent":"WY-z"};